import React, { useState, useEffect } from "react";
import { useAuth } from "../../hooks/GlobalProvider";
import { Contactus, GetPreviousMessages } from "../../hooks/APIHooks";

const ContactUs = () => {
  const { user } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [previousMessages, setPreviousMessages] = useState([]);
  const [expandedQuestion, setExpandedQuestion] = useState(null);

  useEffect(() => {
    if (user) {
      setName(user.name || "Guest");
      setEmail(user.email || "test@gmail.com");
      setNumber(user.phonenumber || "");
      fetchPreviousMessages(user.phonenumber);
    }
  }, [user]);

  const fetchPreviousMessages = async (phonenumber) => {
    try {
      const response = await fetch(GetPreviousMessages, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phonenumber }),
      });
      const data = await response.json();
      if (data.success) {
        setPreviousMessages(data.messages);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const handleSubmit = async () => {
    if (!name || !number || !email || !subject || !message) {
      alert("Please fill in all fields");
      return;
    }
    try {
      const response = await fetch(Contactus, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          number,
          email,
          subject,
          message: "me: " + message.trim() + ";",
        }),
      });
      const result = await response.json();
      if (result.success) {
        alert("Message sent!");
        setSubject("");
        setMessage("");
        fetchPreviousMessages(number);
      } else {
        alert("Message failed. Try again.");
      }
    } catch (error) {
      alert("Error occurred. Try again.");
    }
  };

  const toggleQuestion = (index) => {
    setExpandedQuestion(expandedQuestion === index ? null : index);
  };

  return (
    <section className="bg-primary-100 min-h-screen pt-24">
      <div className="max-w-md mx-auto p-4  text-sm">
        <h1 className="text-xl font-bold text-center mb-2 text-white">
          Contact Us
        </h1>

        <div className="space-y-3">
          <input
            type="text"
            value={subject}
            placeholder="Subject"
            onChange={(e) => setSubject(e.target.value)}
            className="w-full px-3 py-2 border rounded"
          />
          <textarea
            value={message}
            placeholder="Your Message"
            onChange={(e) => setMessage(e.target.value)}
            className="w-full px-3 py-2 border rounded h-24 resize-none"
          />
          <button
            onClick={handleSubmit}
            className="w-full bg-secondary text-white py-2 rounded "
          >
            Send
          </button>
        </div>

        <div className="mt-6">
          <h2 className="text-lg font-semibold mb-2 text-white">FAQs</h2>
          {faqData.map((faq, index) => (
            <div key={index} className="mb-2">
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full text-left text-secondary font-medium"
              >
                {faq.question}
              </button>
              {expandedQuestion === index && (
                <p className="text-gray-300 mt-1">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6">
          <h2 className="text-lg font-semibold mb-2 text-white">
            Previous Messages
          </h2>
          {previousMessages.length > 0 ? (
            previousMessages.map((msg, index) => (
              <div key={index} className="border p-3 rounded mb-2 bg-secondary">
                <p className="font-semibold text-sm">{msg.subject}</p>

                <div className="text-black text-xs space-y-1">
                  {msg.message
                    .split(";")
                    .map((line, idx) =>
                      line.trim() ? <p key={idx}>• {line.trim()}</p> : null
                    )}
                </div>

                <p className="text-gray-500 text-xs">Status: {msg.status}</p>
              </div>
            ))
          ) : (
            <p className="text-gray-400 text-sm">No previous messages found.</p>
          )}
        </div>
      </div>
    </section>
  );
};

const faqData = [
    {
      question: "How many users can I refer?",
      answer: "Each user can refer up to 3 users in each chain. Referrals beyond this limit will not be counted for bonuses.",
    },
    {
      question: "How is the coin bonus calculated?",
      answer: "For each referral in your chain, you earn ₹100 coins if they fall within the bonus ranges. Cooling periods do not give coins.",
    },
    {
      question: "What are cooling periods?",
      answer: "Cooling periods are ranges of referrals where no coins are awarded. For example, 1–13, 27–351, and 704–2916 are cooling periods.",
    },
    {
      question: "When do I receive bonuses?",
      answer: "Bonuses are awarded for the following referral ranges per chain: 14–26, 352–703, and 2917–5833.",
    },
    {
      question: "Is the bonus calculated per chain or total referrals?",
      answer: "The bonus is calculated separately for each chain, not based on your total combined referrals.",
    },
    {
      question: "How can I share my referral link?",
      answer: "You can share your referral link via WhatsApp using the 'Share Referral' button in your dashboard.",
    },
    {
      question: "How do I unlock withdrawal access?",
      answer: "You need to refer 3 or more users in at least one chain to unlock withdrawal access.",
    },
    {
      question: "Can my referrals refer others?",
      answer: "Yes, your referrals can refer their own users, creating a multi-level referral tree. Coins from their referrals are awarded based on the bonus ranges for your chain.",
    },
  ];

export default ContactUs;
